import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmArrowCornerRightUp = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-arrow-corner-right-up",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-arrow-corner-right-up",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      clipRule: "evenodd",
      d: "m23.6 8.7-6.2-6.2-1.9 1.9 4 4h-7.5c-3.2 0-6.2 1.3-8.4 3.5s-3.5 5.3-3.5 8.4v1.3h2.7v-1.3c0-2.5 1-4.8 2.7-6.6 1.7-1.7 4.1-2.7 6.6-2.7h7.4l-4 4 1.9 1.9 6.2-6.2c.5-.7.5-1.5 0-2z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  }));
});
IconLlmArrowCornerRightUp.displayName = 'IconLlmArrowCornerRightUp';

export { IconLlmArrowCornerRightUp };
//# sourceMappingURL=llm-arrow-corner-right-up.js.map
